import { render, staticRenderFns } from "./albaranes.vue?vue&type=template&id=486f3f86&scoped=true"
import script from "./albaranes.vue?vue&type=script&lang=js"
export * from "./albaranes.vue?vue&type=script&lang=js"
import style0 from "./albaranes.vue?vue&type=style&index=0&id=486f3f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486f3f86",
  null
  
)

export default component.exports